if ($('#reviewsVideo').length) {
    $('.reviewsVideoWrapper').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      speed: 300,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            arrows: true,
            centerMode: true,
            centerPadding: '40px'
          }
        },
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 1,
            arrows: false,
            centerMode: true,
            centerPadding: '30px'
          }
        },
        {
          breakpoint: 321,
          settings: {
            slidesToShow: 1,
            arrows: false,
            centerMode: true,
            centerPadding: '15px',
          }
        }
      ]
    });
}